import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { SippApi } from '../../../services/SippExpress'
import { IUrlMapState, UrlMapDocument, UrlMapState } from '../urlMap.slice'

export const GetUrlMapAsync = createAsyncThunk(
  'urlMaps/getUrlMap',
  async (code: string, { rejectWithValue }) => {
    try {
      const response = (await SippApi.fetchUrlMapByCode(code, {})) as AxiosResponse<UrlMapDocument>
      return response.data
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || 'Failed request')
    }
  },
)

export const GetUrlMapAsyncBuilder = (builder: ActionReducerMapBuilder<IUrlMapState>) => {
  builder
    .addCase(GetUrlMapAsync.pending, (state) => {
      state.loading = true
      state.error = false
      state.data = UrlMapState.data
    })

    .addCase(GetUrlMapAsync.fulfilled, (state, action) => {
      state.data = action.payload
      state.loading = false
    })
    .addCase(GetUrlMapAsync.rejected, (state, action: PayloadAction<any>) => {
      state.loading = false
      state.error = true
    })
}
